module.exports = __webpack_public_path__ + "static/media/joyable4_preview.92ae9012.jpg";